module.exports = __webpack_public_path__ + "static/media/OurProcessBackground.32e37585.jpg";